(() => {
  if (window.wtaBackToTopInitialized) return;

  const control = document.querySelector('[data-wta-back-to-top]');
  if (!control) return;

  window.wtaBackToTopInitialized = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;

  const updateControl = () => {
    const threshold = Math.max(520, window.innerHeight * 0.72);
    const isVisible = window.scrollY > threshold;

    control.classList.toggle('is-visible', isVisible);
    control.setAttribute('aria-hidden', String(!isVisible));
    control.tabIndex = isVisible ? 0 : -1;
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateControl);
  };

  control.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
    });
  });

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('pageshow', requestUpdate);
  updateControl();
})();
